import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(650px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -700px;
  width: 700px;
  height: 100%;
  // box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 10px;

  transition: all 0.5s ease-out;

  h1 {
    font-size: 2.5rem;
    font-weight: 600;
  }

  @media (max-width: 850px) {
    right: 0px;
    width: 100%;
    margin-top: 0px;
  }
`;

export const Header = styled.header`
  padding: 10px 20px;

  h1 {
    font-size: 1.5rem;
  }

  h3 {
    font-size: 1.1rem;
    font-weight: 500;
  }
`;

export const ContentBody = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  padding: 20px 20px;
  margin-bottom: 40px;

  @media (max-width: 450px) {
    height: 93%;
  }
`;

export const CategoriaList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 20px;
  list-style: none;
  width: 100%;
  overflow-y: scroll;
`;

export const CategoriaItem = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  border: 1px solid var(--gray-border-lw);
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #eceff1;
  }

  .category-icon {
    padding: 10px;

    svg {
      font-size: 2.3rem;
      color: var(--azul-razio);
      margin-right: 15px;
    }
  }

  .category-description {
    h1 {
      font-size: 1.1rem;
      font-weight: 600;
    }
  }
`;

export const CadastroCategoria = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;

  > h1 {
    font-size: 1.5rem;
    font-weight: 600;
  }
`;

export const CategoriaSelected = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 40px 10px 20px;
  border: 1px solid var(--gray-border-lw);
  border-radius: 5px;
  width: 100%;
  margin-top: 10px;

  .category-data {
    display: flex;
    align-items: center;
    width: 100%;

    .category-icon {
      padding: 10px;

      svg {
        font-size: 2.3rem;
        color: var(--azul-razio);
        margin-right: 15px;
      }
    }

    .category-description {
      h1 {
        font-size: 1.2rem;
        font-weight: 600;
      }
    }
  }

  .category-button {
    display: flex;
    align-items: center;

    button {
      background-color: 0;
      border: 0;
      color: var(--azul-razio);
      font-weight: 600;
    }
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  h1 {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 10px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  bottom: 0;
  position: absolute;
  width: 100%;
  // border: 2px solid red;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 10px 20px;
    margin: 5px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
